import React, {Component} from "react"
import {each} from "lodash"

import {H3, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import tracking from "@irati-tracking/recognition/shared"
import Flex from "@irati/ui/src/Flex"

interface Props {
  onHide: () => void,
  selectScreen: () => void,
  previous: any
}

class CancelConfirm extends Component<Props> {
  static defaultProps = {
    previous: null,
    id: "createChallenge_cancelConfirm"
  }

  getPreviousLocation = () => {
    const {previous} = this.props
    let step = null
    each(previous, (value, key) => {
      if (value === true) {
        step = key
      }
    })
    return step
  }

  handleContinue = () => {
    tracking.cancelContinue()
    const {selectScreen} = this.props
    const step = this.getPreviousLocation()
    selectScreen(step)
  }

  handleQuit = () => {
    const {onHide} = this.props
    tracking.cancelConfirm()
    onHide()
  }

  render() {
    return (
      <Flex direction="column">
        <H3 tiny><FormattedMessage id="recognition.popup.shared.cancelConfirm.header" /></H3>
        <Body small marginBottom={1}>
          <FormattedMessage id="recognition.popup.shared.cancelConfirm.p1" />
        </Body>
        <Flex alignItems="center" justifyContent="flex-end">
          <Button
            tertiary
            id={id("continue", this.props)}
            onClick={this.handleContinue}
            marginRight={2}>
            <FormattedMessage id="recognition.popup.shared.cancelConfirm.continue" />
          </Button>
          <Button
            id={id("quit", this.props)}
            primary
            onClick={this.handleQuit}>
            <FormattedMessage id="recognition.popup.shared.cancelConfirm.quit" />
          </Button>
        </Flex>
      </Flex>
    )
  }
}

export default CancelConfirm
